
import Routes from './routes';
import useRefreshFeatureFlags from '~/hooks/useRefreshFeatureFlags';

export default function App() {
  useRefreshFeatureFlags();
  return <Routes />;
}
